import { DateHelper } from '../utils/date-helper';
import { ResourceType } from './resource-type';

export class Occupancy {

    LessonId: number;

    ReservationId: number;

    ResourceId: number;

    Designation: string;

    Description: string;

    DateTimeFrom: Date;

    DateTimeTo: Date;

    Ressource: string;

    ResourceTypeId: ResourceType;

    VisibleToStudents: boolean;

    DisplayColor: string;

    Type: OccupancyType;

    IsEditable: boolean;

    IdObject: string;

    static create(object: Occupancy): Occupancy {
        const instance = new Occupancy();
        instance.LessonId = object.LessonId;
        instance.ReservationId = object.ReservationId;
        instance.ResourceId = object.ResourceId;
        instance.Designation = object.Designation;
        instance.Description = object.Description;
        instance.DateTimeFrom = DateHelper.parseDateString(object.DateTimeFrom);
        instance.DateTimeTo = DateHelper.parseDateString(object.DateTimeTo);
        instance.Ressource = object.Ressource;
        instance.ResourceTypeId = object.ResourceTypeId;
        instance.VisibleToStudents = object.VisibleToStudents;
        instance.DisplayColor = object.DisplayColor;
        instance.IdObject = object.IdObject;
        instance.Type = object.Type;
        instance.IsEditable = object.IsEditable;
        return instance;
    }
}

/**
 * Type of occupancy
 *
 * @export
 * @enum {number}
 */
export enum OccupancyType {
    // eg. Ressource not availablet due to calendar limitation
    Blocker = 10,
    // The resource is occupied
    Occupancy = 20,

    Reservable = 30,

    Unavailable = 40
}
